import { Separator } from '@carboncopyco/ui';
import classnames from 'classnames';

export const SidebarSeparator = ({ className }: { className?: string }) => (
  <div
    className={classnames(
      'my-ds-1.25 flex items-center justify-center w-full',
      className
    )}
  >
    <Separator
      horizontal
      middle
    />
  </div>
);
